import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import MasterDataTable from './MasterDataTable.vue';
import { getMasterDataApi, suggestMasterDataApi, importMasterDataApi } from '@/api/selfAnalysis';
var TABLE = 'site_inverter_status_codes';
export default {
  name: 'StatusCodesPanel',
  components: {
    MasterDataTable: MasterDataTable
  },
  props: {
    def: {
      type: Object,
      required: true
    },
    siteCode: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      bringing: false,
      notice: '',
      noticeVariant: 'info'
    };
  },
  watch: {
    siteCode: {
      immediate: true,
      handler: function handler(site) {
        var _this = this;
        return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var res;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this.notice = '';
                  if (site) {
                    _context.next = 3;
                    break;
                  }
                  return _context.abrupt("return");
                case 3:
                  _context.prev = 3;
                  _context.next = 6;
                  return getMasterDataApi(TABLE, site);
                case 6:
                  res = _context.sent;
                  if (!(site === _this.siteCode && !(res.data || []).length)) {
                    _context.next = 10;
                    break;
                  }
                  _context.next = 10;
                  return _this.bring(true);
                case 10:
                  _context.next = 15;
                  break;
                case 12:
                  _context.prev = 12;
                  _context.t0 = _context["catch"](3);
                  console.log('status codes auto-fill check failed', _context.t0);
                case 15:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[3, 12]]);
        }))();
      }
    }
  },
  methods: {
    /** @param {boolean} auto 自動帶入時，INV主檔沒品牌就安靜提示，不當錯誤 */bring: function bring(auto) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var site, _yield$suggestMasterD, data, brands, missing, res, msg;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                site = _this2.siteCode;
                _this2.bringing = true;
                _context2.prev = 2;
                _context2.next = 5;
                return suggestMasterDataApi(TABLE, site);
              case 5:
                _yield$suggestMasterD = _context2.sent;
                data = _yield$suggestMasterD.data;
                if (!(site !== _this2.siteCode)) {
                  _context2.next = 9;
                  break;
                }
                return _context2.abrupt("return");
              case 9:
                brands = data.brands.map(function (b) {
                  return "".concat(b.brand, " ").concat(b.model);
                }).join('、');
                missing = data.unmatched.length ? "\uFF1B\u54C1\u724C\u5EAB\u6C92\u6709 ".concat(data.unmatched.join('、'), "\uFF0C\u8ACB\u624B\u52D5\u65B0\u589E") : '';
                if (data.rows.length) {
                  _context2.next = 14;
                  break;
                }
                _this2.say("INV\u4E3B\u6A94\u7684\u54C1\u724C\uFF08".concat(brands, "\uFF09\u5728\u54C1\u724C\u5EAB\u627E\u4E0D\u5230\uFF0C\u8ACB\u624B\u52D5\u65B0\u589E\u72C0\u614B\u78BC"), 'warning');
                return _context2.abrupt("return");
              case 14:
                _context2.next = 16;
                return importMasterDataApi(TABLE, data.rows);
              case 16:
                res = _context2.sent;
                _this2.say("".concat(auto ? '已自動' : '已', "\u4F9D INV\u4E3B\u6A94\uFF08").concat(brands, "\uFF09\u5E36\u5165\uFF1A").concat(res.msg).concat(missing), missing ? 'warning' : 'info');
                _this2.$refs.table.load();
                _this2.$emit('changed');
                _context2.next = 26;
                break;
              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2["catch"](2);
                msg = (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.msg) || (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || '帶入失敗';
                _this2.say(msg, auto ? 'secondary' : 'danger');
              case 26:
                _context2.prev = 26;
                _this2.bringing = false;
                return _context2.finish(26);
              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 22, 26, 29]]);
      }))();
    },
    say: function say(msg, variant) {
      this.notice = msg;
      this.noticeVariant = variant;
    }
  }
};